<script setup lang="ts">
import useSimpleUIGUard from '@kidzonet/use-simple-ui-guard'

import Content from './Content.vue'
import Switcher from './Switcher.vue'

useSimpleUIGUard()
</script>

<template>
    <div>
        <Switcher class="kidzonet-dashboard-widget" />
        <Content />
    </div>
</template>
